import { createSlice } from "@reduxjs/toolkit";
import { VolunteerInitialLoad, VolunteerPaggination } from "../thunk/VolunteerThunk";



const initialState = {
    volunteers: [],
    errorMessage: '',
    successMessage: '',
    showLoading: false,
};


export const VolunteersSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        resetVolunteers: (state, action) => {
            return {
                ...initialState
            };

        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(VolunteerInitialLoad.pending, (state, action) => {
                return { ...state, showLoading: true };
            })
            .addCase(VolunteerInitialLoad.fulfilled, (state, action) => {

                // console.log({ action });

                return {
                    ...state,
                    volunteers: action.payload,
                    errorMessage: '',
                    successMessage: '',
                    showLoading: false,
                };
            })
            .addCase(VolunteerInitialLoad.rejected, (state, action) => {
                let errorMessage;
                if (action.payload) {
                    // Being that we passed in ValidationErrors to rejectType in `createAsyncThunk`, the payload will be available here.
                    errorMessage = action.payload;
                } else {
                    errorMessage = action.error.message?.toString();
                }

                return { ...state, errorMessage, showLoading: false }
            })
            .addCase(VolunteerPaggination.pending, (state, action) => {
                return { ...state, showLoading: true };
            })
            .addCase(VolunteerPaggination.fulfilled, (state, action) => {

                // console.log({ action });

                return {
                    ...state,
                    volunteers: action.payload,
                    errorMessage: '',
                    successMessage: '',
                    showLoading: false,
                };
            })
            .addCase(VolunteerPaggination.rejected, (state, action) => {
                let errorMessage;
                if (action.payload) {
                    // Being that we passed in ValidationErrors to rejectType in `createAsyncThunk`, the payload will be available here.
                    errorMessage = action.payload;
                } else {
                    errorMessage = action.error.message?.toString();
                }

                return { ...state, errorMessage, showLoading: false }
            });
    },
});


export const { resetVolunteers } = VolunteersSlice.actions;

export const VolunteersReducer = VolunteersSlice.reducer;